import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import useMarketingFonts from '../marketing/useMarketingFonts';
import useSeoHead from '../marketing/useSeoHead';
import MarketingNav from '../marketing/components/MarketingNav';
import MarketingFooter from '../marketing/components/MarketingFooter';
import SimplePageHero from '../marketing/components/SimplePageHero';
import { GUIDES } from '../marketing/data';
import { marketingColors as C, marketingFonts as F } from '../theme_landing_page';

const pillarLabel: Record<string, string> = { compliance: 'Compliance', accounting: 'Accounting', management: 'Management' };

const GuidesIndexPage: React.FC = () => {
  useMarketingFonts();
  useSeoHead({
    title: 'UK Landlord Guides — 7 Pillar Guides | MillOS',
    description: 'Seven definitive pillar guides for UK landlords: compliance, accounting, property tax, portfolio management, HMOs, buy-to-let investing and Open Banking.',
    canonicalPath: '/guides',
  });

  return (
    <Box className="lv-marketing" sx={{ background: C.white, color: C.ink, fontFamily: F.body, fontSize: 16, lineHeight: 1.5, overflowX: 'hidden' }}>
      <MarketingNav />
      <SimplePageHero
        eyebrow="Pillar guides"
        title={<>The MillOS <Box component="em" sx={{ fontStyle: 'italic' }}>Guides</Box></>}
        body="Seven definitive, long-form references for running a compliant, profitable UK property portfolio."
      />
      <Box component="section" sx={{ padding: { xs: '48px 16px 64px', md: '56px 52px 96px' } }}>
        <Box sx={{ maxWidth: 1000, margin: '0 auto', display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: '24px' }}>
          {GUIDES.map((g) => (
            <Box
              key={g.slug}
              component={RouterLink}
              to={`/guides/${g.slug}`}
              sx={{ display: 'flex', flexDirection: 'column', gap: '20px', background: C.panel, borderRadius: '28px', padding: '36px', height: '100%', '&:hover': { background: C.tintBlue } }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                <Box sx={{ background: C.white, color: C.accent, border: '1px solid rgba(0,0,0,0.08)', borderRadius: '32px', padding: '5px 14px', fontSize: 11, fontWeight: 500, letterSpacing: '0.06rem', textTransform: 'uppercase' }}>
                  {pillarLabel[g.pillar] || g.pillar}
                </Box>
                <Box sx={{ fontSize: 13, color: C.muted }}>{g.readingMinutes} min · {g.wordCount.toLocaleString()} words</Box>
              </Box>
              <Box component="h2" sx={{ fontFamily: F.display, fontWeight: 400, fontSize: 30, lineHeight: 1.12, letterSpacing: '-0.02em', margin: 0 }}>
                {g.title}
              </Box>
              <Box sx={{ color: C.body, fontSize: 15, lineHeight: 1.55 }}>{g.description}</Box>
              <Box sx={{ marginTop: 'auto', fontSize: 14, fontWeight: 500, color: C.accent }}>Read the guide →</Box>
            </Box>
          ))}
        </Box>
      </Box>
      <MarketingFooter />
    </Box>
  );
};

export default GuidesIndexPage;
